import { State } from "./state";
import { MutationTree } from "vuex";
import { SET_LOCAL_FILTER } from "./types";

export default <MutationTree<State>>{
  [SET_LOCAL_FILTER](state: State, payload: any) {
    Object.assign(state, { filter: payload });
  },
};
